import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import { useParams } from 'react-router';
import { CardSmallGrid } from '../core/card/CommonCardLayouts';
import LicenseExpiredBannerCard from '../license/LicenseExpiredBannerCard';
import SplashLoader from '../loading/SplashLoader';
import OrgBillingComponents from './billing/OrgBillingComponents';
import OrgInvitesCard from './invite/OrgInvitesCard';
import LicenseKeyCard from './licenseKey/LicenseKeyCard';
import ManagedOrgCard from './managedOrg/ManagedOrgCard';
import OrgMemberCard from './member/OrgMemberCard';
import OrgProfilesCard from './OrgProfilesCard';
import OrgProductLandingCard from './product/OrgProductLandingCard';
import OrgProjectsCard from './projects/OrgProjectsCard';
import OrgSettingsCard from './settings/OrgSettingsCard';

interface IOrgPageContentProps {
    isAdminPortal?: boolean;
}

export default function OrgPageContent({ isAdminPortal = false }: IOrgPageContentProps) {
    const {
        currentOrg,
        hasSomeMemberEditPermissions,
        isExpiredOrg,
        canManageBilling,
        canViewMembers,
        canInviteMembers,
        canCreateAuthClients,
        canViewAuthClients,
        canViewOrgDetails,
        isLoading,
        canManageChildOrganizations,
        canAccessOrganizationProfiles,
        canEditOrganizationProfiles,
    } = useCurrentOrgDetailsFetching();
    const { managedOrg } = useParams();

    if (!currentOrg) return null;
    if (isLoading) return <SplashLoader />;
    if (isExpiredOrg)
        return <LicenseExpiredBannerCard organizationId={currentOrg.id} canManageBilling={canManageBilling} />;

    if (!canViewOrgDetails) {
        return (
            <CardSmallGrid>
                <OrgBillingComponents currentOrg={currentOrg} canManageBilling={canManageBilling} />
            </CardSmallGrid>
        );
    }

    return (
        <>
            {(canViewMembers || hasSomeMemberEditPermissions) && <OrgMemberCard orgId={currentOrg.id} />}
            {canInviteMembers && <OrgInvitesCard orgId={currentOrg.id} />}
            {(canAccessOrganizationProfiles || canEditOrganizationProfiles) && isAdminPortal && (
                <OrgProfilesCard orgId={currentOrg.id} />
            )}

            {/* {(currentOrg.canCreateAuthClients || currentOrg.isAdmin) && (
                    <OrgMetricsCard orgId={currentOrg.organizationId} />
                )} */}

            {!managedOrg && currentOrg.isReseller && canManageChildOrganizations && isAdminPortal && (
                <>
                    <ManagedOrgCard orgId={currentOrg.id} />
                    <LicenseKeyCard orgId={currentOrg.id} />
                    <OrgProductLandingCard orgId={currentOrg.id} />
                    {/* <OrgLicenseKeyCard orgId={currentOrg.organizationId} /> */}
                </>
            )}
            {canCreateAuthClients && isAdminPortal && (
                <OrgProjectsCard orgId={currentOrg.id} projects={currentOrg.canCreateAuthClients} />
            )}
            <OrgSettingsCard orgId={currentOrg.id} />
        </>
    );
}
